export const environment = {
    production: false,
    pedidosApi: 'https://erp-portal-privado-pedidos.azurewebsites.net',
    chatApi: 'https://erp-portal-privado-pedidos.azurewebsites.net',
    cepApi: 'https://viacep.com.br/ws/',
    gestaoDocumentosApi: 'https://gestao-documentos-temp.azurewebsites.net/api',    
    gestaoDocumentosDownloadApi: 'https://gestao-documentos-storage.azurewebsites.net/api/downloadArquivo/',
    featureFlagApi: 'https://erp-app-configuration.azconfig.io/FeatureFlag/',
    keycloak: {
        url: 'https://keycloak-dev.conekt.cloud/',
        clientId: 'erp'
    }
}